<template>
  <div id="dynamicDetails"> 
    <Navigation/>
    <div class="container-fluid container_fluid">
      <div class="row fluid_row">
        <div class="col-lg-7">
          <h3 v-text="dynamic.title" class="title"></h3>
        </div>
        <div class="col-lg-7">
          <div class="cont" v-html="dynamic.content"></div>
        </div>
      </div>
    </div>
    <ReturnTop/>
    <HeadTail/>
  </div>
</template>

<script>
import navigation from './publicComponent/Navigation'
import headTail from './publicComponent/HeadTail'
import returnTop from './publicComponent/ReturnTop'
export default {
  data(){
    return{
      dynamic:{},
      slientWidth:document.body.clientWidth, 
      flag: 3,
    }
  },
  created(){
    let id = this.$route.query.aid
    if(document.body.clientWidth > 750){
      this.$http.get("https://api.hanfangyiyang.cn/cms/ter_article/"+id).then(res =>{
          var marked = require('marked');
          res.data.data.content=marked(res.data.data.content);
          res.data.data.content=res.data.data.content.replace(/img /g,'img style="width:100%;"').
          replace(/<p>/g,'<p style="width: 100%;padding: 1vh 0 1vh 0 !important;font-size: 18pt;font-weight: 340;color:#333333;">').
          replace(/<p style="width: 100%;padding: 1vh 0 1vh 0 !important;font-size: 2.2vw;font-weight: 340;"><img/g,'<p><img')
          var htm="";
          this.dynamic = res.data.data
      })
    }else{
      this.$http.get("https://api.hanfangyiyang.cn/cms/ter_article/"+id).then(res =>{
          var marked = require('marked');
          res.data.data.content=marked(res.data.data.content);
          res.data.data.content=res.data.data.content.replace(/img /g,'img style="width:100%;"').
          replace(/<p>/g,'<p style="width: 100%;padding: 0.5vh 1vw 0.5vh 1vw !important;font-size: 14pt;font-weight: 340;color:#333333;">').
          replace(/<p style="width: 100%;padding: 0.5vh 1vw 0.5vh 1vw !important;font-size: 14pt;font-weight: 340;"><img/g,'<p><img')
          var htm="";
          this.dynamic = res.data.data
      })
    }
  },
  methods:{
      
  },
  components: {
    'HeadTail': headTail,  //将别名demo 变成 组件 Demo
    "Navigation":navigation,
    "ReturnTop" : returnTop
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 750px){
  .container_fluid{
    margin-top: 15vh !important; 
  }
  .fluid_row{
    display: flex;
    /* justify-content: center; */
    flex-direction: column;
    align-items: center;
  }
  .title{
    text-align: center;
    font-size: 38pt;
  }
  .cont{
    margin-top: 5vh !important;
    margin-bottom: 3vh !important;
  }
}

/* 移动端特殊样式 */
@media screen and (max-width: 750px){
  .container_fluid{
    margin-top: 2vh !important; 
  }
  .fluid_row{
    display: flex;
    /* justify-content: center; */
    flex-direction: column;
    align-items: center;
  }
  .title{
    text-align: center;
    font-size: 20pt;
  }
  .cont{
    margin-top: 2vh !important;
    margin-bottom: 3vh !important;
  }
    
}

</style>



// WEBPACK FOOTER //
// src/components/DynamicDetails.vue